// extracted by mini-css-extract-plugin
export default {"ctaStrip":"CtaStrip_ctaStrip__POmBY","ctaText":"CtaStrip_ctaText__EyfjA","btnPrimarySmall":"CtaStrip_btnPrimarySmall__EqXCN"};